// extracted by mini-css-extract-plugin
module.exports = {"slider":"_3bWUya","slide":"_1_ItN8","pointer":"_14Ixmj"};